import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

// Compare levels ignoring surrounding spaces and full-width/half-width differences (e.g. "Ｎ５ " === "N5")
const normalizeLevel = (level?: string | null) => (level ?? "").normalize("NFKC").trim();

// This page shows the max length without 「」 (the shared INVALID_STRING_MAX wraps it)
const MAX_TEXT_LENGTH = 255;
const maxLengthMessage = ({ label, max }: { label?: string; max: number }) => `「${label}」は最大${max}文字で入力してください。`;

export const languageTestLevelSchema = validator.object().shape({
  level: validator.string().emptyToNull().max(MAX_TEXT_LENGTH, maxLengthMessage).label("レベル").required(),
  ikuseiJapaneseRequirementIndicator: validator.number().isSelection().emptyToNull().label("育成就労日本語要件判断指標").notRequired(),
});

export const masterDataLanguageTestSchema = validator.object().shape({
  languageTestName: validator.string().emptyToNull().max(MAX_TEXT_LENGTH, maxLengthMessage).label("試験名（日本語）").required(),
  ckLanguageTestRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("期間更新CSVのコード（列CK）")
    .required(),
  languageTestLevels: validator
    .array()
    .of(languageTestLevelSchema)
    .label("レベル一覧")
    .required()
    .test("uniqueLevel", function (languageTestLevels) {
      const levels = (languageTestLevels ?? []).map((languageTestLevel) => normalizeLevel(languageTestLevel.level));
      const duplicatedIndex = levels.findIndex((level, index) => level && levels.indexOf(level) !== index);
      if (duplicatedIndex === -1) {
        return true;
      }
      return this.createError({
        path: `${this.path}.${duplicatedIndex}.level`,
        message: `「レベル」（${languageTestLevels?.[duplicatedIndex]?.level}）が入力内で重複しています。`,
      });
    }),
});
